import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchPointCommand } from '@puppycad/cad-core';
import PointPropertySection from '@/components/editor/property-manager/point/PointPropertySection.vue';

registerPropertyManagerSection({
  id: SketchPointCommand.Point,
  title: '点',
  order: 15,
  component: PointPropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.pointPropertyVisible === true),
});
